import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

interface BazzskeltonProps {
	list: Array<number>
}

export default function Bazzskelton(props: BazzskeltonProps) {
	return (
		<Grid container spacing={0} width="100%">
			{props.list.map((times: number) =>
				<Grid item xs={12} sm={props.list.length === 2 ? 6 : props.list.length === 3 ? 4 : 2} key={times} padding={1}>
					<Skeleton variant="rectangular" height={160} />
					<Skeleton animation="wave" />
					<Skeleton animation='wave' />
				</Grid>
			)}
		</Grid>
	);
}
